import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const IndexPageContainer = styled.div`
  margin: 0 ${spacing.base};
  padding: 0 ${spacing.double};
`;
